import type { TOC } from '@ember/component/template-only';

interface MoreButtonSignature {
  Element: SVGElement;
}

export default <template>
  <svg ...attributes class="more-button" width="28" height="14" viewBox="0 0 18 4" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.8 3.604a1.8 1.8 0 0 0 1.8-1.802 1.8 1.8 0 1 0-1.8 1.802zm7.2 0a1.8 1.8 0 0 0 1.8-1.802A1.8 1.8 0 1 0 9 3.604zm7.2 0A1.8 1.8 0 0 0 18 1.802a1.8 1.8 0 1 0-1.8 1.802z"
      fill="#898B91"
      fill-rule="evenodd"
    ></path>
  </svg>
</template> satisfies TOC<MoreButtonSignature>;
